<template>
  <div class="mySubscribe-set" v-loading="showloading">
    <template v-if="!hasInfo">
      <el-button size="mini" type="primary" @click="addFun">添加</el-button>
    </template>
    <template v-else>
      <el-button size="mini" type="primary" @click="changeFun">修改</el-button>
      <el-button size="mini" type="primary" @click="cancelFun"
        >取消订阅</el-button
      >
      <el-form
        class="myform mt20"
        :model="infos"
        ref="infos"
        label-width="130px"
        size="small"
      >
        <el-form-item label="物资分类:">
          <span>{{ infos.typeNames }}</span>
        </el-form-item>
        <el-form-item label="所在省市:">
          <span>{{ infos.proviceNames }}</span>
        </el-form-item>
        <el-form-item label="是否需要短信通知:">
          <span>{{ infos.whetherSend === 1 ? '是' : '否' }}</span>
        </el-form-item>
      </el-form>
    </template>
    <!-- 新增弹框 -->
    <el-dialog
      :show-close="false"
      width="900px"
      @closed="close"
      :visible.sync="showDialog"
    >
      <p class="title">{{ title }}</p>
      <p class="tips">
        <i class="el-icon-warning warnboxicn"></i>
        请设置您要订阅的公告的筛选条件，系统将根据您的设置向您实时推送新发布的公告
      </p>
      <div class="content">
        <el-form
          class="myform"
          :model="form"
          ref="form"
          label-width="130px"
          size="small"
        >
          <el-form-item label="物资分类:">
            <el-checkbox-group v-model="form.types">
              <el-checkbox
                v-for="item in typeList"
                :key="item.codeCode"
                :label="item.codeCode"
                class="checkboxs"
              >
                {{ item.codeName }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- <p class="formtips">（最多选择三种分类）</p> -->
          <el-form-item label="所在省市:">
            <el-checkbox-group v-model="form.provices">
              <el-checkbox
                v-for="item in provicesList"
                :key="item.codeCode"
                :label="item.codeCode"
                class="checkboxs"
              >
                {{ item.codeName }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <!-- <p class="formtips">（最多选择5个省市）</p> -->
        <el-form
          class="myform"
          :model="formData"
          ref="formData"
          label-width="130px"
          size="small"
          :rules="rules"
        >
          <el-form-item label="是否需要短信通知:">
            <el-radio-group v-model="form.whetherSend" @change="changeRadio">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <p class="formtips">{{ tips }}</p> -->
          <el-row v-if="form.whetherSend == 1">
            <el-col :span="7"
              ><el-form-item label="手机1:" prop="sendPhone1">
                <el-input
                  v-model="formData.sendPhone1"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="7" v-if="sendcode > 1"
              ><el-form-item label="手机2:" prop="sendPhone2">
                <el-input
                  v-model="formData.sendPhone2"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="7" v-if="sendcode > 2"
              ><el-form-item label="手机3:" prop="sendPhone3">
                <el-input
                  v-model="formData.sendPhone3"
                ></el-input> </el-form-item
            ></el-col>
            <el-button
              v-if="sendcode < 3"
              size="mini"
              class="buttonstyle"
              type="primary"
              @click="onAdd"
              >添加</el-button
            >
            <el-button
              v-if="sendcode > 1"
              size="mini"
              class="buttonstyle"
              type="primary"
              @click="onDelete"
              >删除</el-button
            >
          </el-row>
        </el-form>
      </div>
      <template v-if="!hasInfo">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitAdd">确认</el-button>
          <el-button type="default" @click="showDialog = false">
            暂不订阅
          </el-button>
        </span>
      </template>
      <template v-else>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitAdd">保存</el-button>
          <el-button type="default" @click="showDialog = false">返回</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import utils from '@/utils/filters'
export default {
  name: 'MySubscribeSet',
  data() {
    return {
      sendcode: 1,
      showloading: false,
      title: '新增订阅',
      hasInfo: false,
      showDialog: false,
      form: {
        types: [],
        provices: [],
        whetherSend: ''
      },
      formData: {
        sendPhone1: '',
        sendPhone2: '',
        sendPhone3: ''
      },
      infos: {
        typeNames: '',
        proviceNames: '',
        whetherSend: ''
      },
      typeList: [],
      provicesList: [],
      tips: '',
      mobile: '',
      rules: {
        sendPhone1: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: '请输入正确的手机号'
          }
        ],
        sendPhone2: [
          {
            required: false,
            pattern: /^1[0-9]{10}$/,
            message: '请输入正确的手机号'
          }
        ],
        sendPhone3: [
          {
            required: false,
            pattern: /^1[0-9]{10}$/,
            message: '请输入正确的手机号'
          }
        ]
      }
    }
  },
  created() {
    this.getMaterials()
    this.getCity()
    setTimeout(() => {
      this.getNotice()
    }, 200)
  },
  methods: {
    // 判断手机号是否存在
    initMobile(whetherSend) {
      const mobile = localStorage.getItem('mobile')
      if (mobile) {
        this.mobile = utils.replaceMobile(mobile)
        if (whetherSend === 1) {
          this.tips = `（您已选择是，当有符合筛选条件的新公告发布时，将会以短信形式发送至手机号${this.mobile}）`
        }
        if (whetherSend === 0) {
          this.tips = '（您已选择否，系统将不会推送新公告的短信）'
        }
      } else {
        this.tips =
          '（系统未获取您的手机号，请将个人信息补充完整后方可进行该项操作）'
        this.mobile = ''
      }
    },
    // 获取物资分类
    async getMaterials() {
      const data = await this.$api.mySubscribe.getMaterial({
        classCode: 'WZCZ_MATES',
        higherCode: 0
      })
      this.typeList = data.data
    },
    // 获取省市
    async getCity() {
      const data = await this.$api.mySubscribe.getProvices({
        classCode: 'COUNTRYREGIONSANDPROVINCES',
        higherCode: 148
      })
      this.provicesList = data.data
    },
    // 获取订阅详情
    async getNotice() {
      const data = await this.$api.mySubscribe.getSubscribe()
      // this.initMobile(data.whetherSend)

      if (!data.mateIds) {
        this.hasInfo = false
        // this.showDialog = true
      } else {
        const obj = {
          whetherSend: data.whetherSend,
          types: data.mateIds.split(','),
          provices: data.provinceIds.split(',')
        }
        this.handleInfos(obj)
        this.hasInfo = true
        this.showloading = false
      }
      if (data.whetherSend == 1) {
        if (data.sendPhone) {
          let sendPhonelist = data.sendPhone.split(',')
          this.sendcode = sendPhonelist.length
          this.formData.sendPhone1 = sendPhonelist[0]
          this.formData.sendPhone2 = sendPhonelist[1]
          this.formData.sendPhone3 = sendPhonelist[2]
        } else {
          this.formData.sendPhone1 = localStorage.getItem('mobile')
        }
      }
    },
    // 新增
    addFun() {
      this.form.whetherSend = ''
      this.form.types = []
      this.form.provices = []
      this.title = '新增订阅'
      this.hasInfo = false
      if (this.mobile) {
        this.tips = ''
      } else {
        this.tips =
          '（系统未获取您的手机号，请将个人信息补充完整后方可进行该项操作）'
      }
      this.showDialog = true
    },
    // 修改物资分类
    typeChange() {
      // if (this.form.types.length > 3) {
      //   this.form.types.shift()
      // }
    },
    // 修改城市
    provicesChange() {
      // if (this.form.provices.length > 5) {
      //   this.form.provices.shift()
      // }
    },
    // 修改手机通知状态
    changeRadio(val) {
      if (val == 1) {
        this.formData.sendPhone1 = JSON.parse(
          localStorage.getItem('loginInfo')
        ).mobile
      } else {
        this.formData.sendPhone1 = ''
        this.formData.sendPhone2 = ''
        this.formData.sendPhone3 = ''
        this.sendcode = 1
      }
      // if (!this.mobile) {
      //   return
      // }
      // const arr = [
      //   '（您已选择否，系统将不会推送新公告的短信）',
      //   `（您已选择是，当有符合筛选条件的新公告发布时，将会以短信形式发送至手机号${this.mobile}）`
      // ]
      // this.tips = arr[e]
    },
    onAdd() {
      this.sendcode = this.sendcode + 1
    },
    onDelete() {
      this.sendcode = this.sendcode - 1
    },
    // 提交新增
    async submitAdd() {
      const result = this.ruleForm()
      console.log(result)
      if (!result) return
      let arr = []
      console.log(this.formData)
      if (this.form.whetherSend == 1) {
        for (let key in this.formData) {
          if (this.formData[key]) {
            arr.push(this.formData[key])
          }
        }
      }
      const obj = {
        sendPhone: this.form.whetherSend == 1 ? arr.toString() : '',
        mateIds: this.form.types.toString(),
        provinceIds: this.form.provices.toString(),
        whetherSend: this.form.whetherSend
      }
      const data = await this.$api.mySubscribe.changeOrSave(obj)
      if (data) {
        this.$message.success('操作成功')
        this.hasInfo = true
        this.showDialog = false
        this.handleInfos(this.form)
      }
    },
    // 保存处理
    handleInfos(form) {
      const typeArr = []
      form.types.map(element => {
        const obj = this.typeList.find(item => item.codeCode === element)
        obj && typeArr.push(obj.codeName)
      })
      this.infos.typeNames = typeArr.toString()
      const provArr = []
      form.provices.map(element => {
        const obj = this.provicesList.find(item => item.codeCode === element)
        obj && provArr.push(obj.codeName)
      })
      this.infos.proviceNames = provArr.toString()
      this.infos.whetherSend = form.whetherSend
    },
    // 修改
    changeFun() {
      this.title = '修改订阅'
      this.showDialog = true
      this.initForms()
    },
    initForms() {
      const typeArr = []
      this.infos.typeNames.split(',').map(element => {
        const obj = this.typeList.find(item => item.codeName === element)
        obj && typeArr.push(obj.codeCode)
      })
      this.form.types = typeArr
      const provArr = []
      this.infos.proviceNames.split(',').map(element => {
        const obj = this.provicesList.find(item => item.codeName === element)
        obj && provArr.push(obj.codeCode)
      })
      this.form.provices = provArr
      this.form.whetherSend = this.infos.whetherSend
      // this.initMobile(this.form.whetherSend)
    },
    // 取消订阅
    cancelFun() {
      this.$confirm('取消订阅以后，系统将不再给您推送公告。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cancelInfos()
      })
    },
    // 关闭弹框修改
    close() {
      this.showloading = false
    },
    // 取消订阅
    async cancelInfos() {
      const data = await this.$api.mySubscribe.delSubscribe()
      if (data) {
        this.$message.success('您已取消订阅')
        this.infos.typeNames = ''
        this.infos.proviceNames = ''
        this.infos.whetherSend = ''
        this.hasInfo = false
      }
    },
    // 校验必填
    ruleForm() {
      let flag = false
      this.$refs.formData.validate(valid => {
        if (valid) {
          const { types, provices } = this.form
          if (!types.length) {
            this.$message({
              type: 'error',
              message: '请选择物资分类'
            })
            return
          }
          if (!provices.length) {
            this.$message({
              type: 'error',
              message: '请选择所在省市'
            })
            return
          }
          flag = true
        }
      })
      return flag
      //   if(whetherSend === '') {
      //     this.$message({
      //       type: 'error',
      //       message: '请选择是否短信通知'
      //     })
      //     return false
      //   }
    }
    // 提交修改
    // submitUpdate(){
    //   console.log(this.form)
    //   const result = this.ruleForm()
    //   if (!result) return
    //   this.infos = JSON.parse(JSON.stringify(this.form))
    //   this.hasInfo = true
    //   this.showDialog = false
    // }
  }
}
</script>
<style>
.el-popup-parent--hidden {
  padding-right: 0 !important;
}
</style>
<style lang="less" scoped>
.mySubscribe-set {
  padding-top: 10px;

  /deep/ .el-dialog__header {
    display: none;
  }

  .title {
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }

  /deep/ .el-dialog__body {
    color: #000;
    padding: 20px 20px 0;
  }

  /deep/ .el-dialog__footer {
    text-align: center;
  }

  .formtips {
    text-indent: 120px;
    color: #666666;
    margin: -10px 0 20px;
  }

  .tips {
    line-height: 40px;
    text-align: center;
    margin-top: 10px;

    .warnboxicn {
      color: red;
      margin-right: 5px;
    }
  }

  .myform /deep/ .el-form-item__label,
  /deep/ .el-checkbox,
  /deep/ .el-radio {
    color: #000;
  }

  .mt20 {
    margin-top: 20px;
  }

  .checkboxs {
    min-width: 140px;
    margin-right: 0;
  }
  /deep/ .el-form-item--small .el-form-item__content,
  /deep/ .el-form-item--small .el-form-item__label {
    line-height: 20px;
  }
}
::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
}
.buttonstyle {
  font-size: 12px;
  height: 27px;
  line-height: 27px;
  padding: 0 15px;
  margin-left: 15px;
  border: none;
}
</style>
